module.exports = __webpack_public_path__ + "img/card_moment@2x.d2613bc5.png";